import { useQuery } from '@tanstack/react-query';
import { getDocumentTemplates } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const useDocumentTemplatesQuery = () => {
	const { data, isLoading, isFetching, refetch } = useQuery({
		queryKey: [API_PATHS.DOCUMENT_TEMPLATES_GET],
		queryFn: ({ signal }) => getDocumentTemplates(signal),
	});

	return {
		templates: data ?? [],
		isLoading,
		isFetching,
		refetch,
	};
};
